import { DebuggerManager } from "@/stores/DebuggerManager";
import { XIcon } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useState } from "react";

export interface StateDataModalProps {
  manager: DebuggerManager;
  isVisible: boolean;
  onClose: () => void;
}

export const StateDataModal = observer(({ manager, isVisible, onClose }: StateDataModalProps) => {
  const [tab, setTab] = useState<string>("user");

  if (!isVisible) return null;

  return (
    <div className={`pyne-debugger-v2__state-data-modal-container ${isVisible ? "visible" : "invisible"}`}>
      <div className="pyne-debugger-v2__state-data-modal-content" style={{ width: 260 }}>
        <div className="pyne-debugger-v2__state-data-modal-header">
          <h2>State data</h2>
          <button className="close-button" onClick={onClose}>
            <XIcon style={{ width: 20, height: 20 }} />
          </button>
        </div>
        <div className="pyne-debugger-v2__state-data-modal-container-header">
          <div className="pyne-debugger-v2__state-data-modal-tab-buttons">
            <button
              className={`pyne-debugger-v2__state-data-modal-tab-button ${tab === "user" ? "active" : ""}`}
              onClick={() => setTab("user")}
            >
              User
            </button>
            <button
              className={`pyne-debugger-v2__state-data-modal-tab-button ${tab === "tour" ? "active" : ""}`}
              onClick={() => setTab("tour")}
            >
              Tour
            </button>
          </div>
        </div>
        <div className="pyne-debugger-v2__state-data-modal-container-body">
          {tab === "user" && <UserStateDetails manager={manager} />}
        </div>
      </div>
    </div>
  );
});

export const UserStateDetails = observer(({ manager }: { manager: DebuggerManager }) => {
  const userState = manager.userState;
  return (
    <div className="pyne-debugger-v2__details-container">
      <div>
        <div className="pyne-debugger-v2__details-title">Finished Tours</div>
        {Array.from(new Set(userState.finishedTourGuideIds)).map((guideId, index) => (
          <div key={index} className="pyne-debugger-v2__details-value">
            • {guideId}
          </div>
        ))}
      </div>
      <div>
        <div className="pyne-debugger-v2__details-title">Dismissed Tours</div>
        {Array.from(new Set(userState.dismissedTourGuideIds)).map((guideId, index) => (
          <div key={index} className="pyne-debugger-v2__details-value">
            • {guideId}
          </div>
        ))}
      </div>
      <div>
        <div className="pyne-debugger-v2__details-title">Dismissed Checklists</div>
        {Array.from(new Set(userState.dismissedChecklistIds)).map((checklistId, index) => (
          <div key={index} className="pyne-debugger-v2__details-value">
            • {checklistId}
          </div>
        ))}
      </div>
    </div>
  );
});
